const zoomTriggerSelector = '[on\\:click^="#zoom-dialog-"], [on\\:click^="/zoom/"]';

let zoomScriptsPromise;

function loadZoomScripts() {
  if (!zoomScriptsPromise) {
    document.documentElement.dataset.spZoomScripts = 'loading';
    zoomScriptsPromise = Promise.all([
      import('@theme/zoom-dialog'),
      import('@theme/drag-zoom-wrapper'),
      import('@theme/media-gallery'),
    ])
      .then(() => Promise.all([customElements.whenDefined('zoom-dialog'), customElements.whenDefined('media-gallery')]))
      .then(() => {
        document.documentElement.dataset.spZoomScripts = 'loaded';
      })
      .catch((error) => {
        document.documentElement.dataset.spZoomScripts = 'error';
        zoomScriptsPromise = undefined;
        console.warn('[Starryve] Unable to load product zoom scripts.', error);
        throw error;
      });
  }

  return zoomScriptsPromise;
}

function findZoomTrigger(event) {
  const target = event.target;

  return target instanceof Element ? target.closest(zoomTriggerSelector) : null;
}

function primeZoomScripts(event) {
  if (!findZoomTrigger(event)) return;

  loadZoomScripts().catch(() => {});
}

function replayClick(trigger) {
  window.requestAnimationFrame(() => {
    trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
  });
}

document.addEventListener(
  'click',
  (event) => {
    const trigger = findZoomTrigger(event);

    if (!trigger || (customElements.get('zoom-dialog') && customElements.get('media-gallery'))) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    loadZoomScripts()
      .then(() => replayClick(trigger))
      .catch(() => {});
  },
  { capture: true }
);

document.addEventListener('pointerover', primeZoomScripts, { capture: true, passive: true });
document.addEventListener('touchstart', primeZoomScripts, { capture: true, passive: true });
